import { Container } from "@/atoms";
import { LayoutProps } from "@/components/layouts/BaseLayout";
import Layout from "@/components/layouts/Layout";
import { revalidateTimeout } from "@/lib/constants";
import { getGlobalElements } from "@/utils/drupal/get-global-elements";
import { GetServerSidePropsContext, GetStaticPropsContext, GetStaticPropsResult } from "next";
import { useEffect } from "react";


export default function NavidulGaming({ blocks }: LayoutProps) {

    useEffect(() => {
        // Crear el script completo con su contenido
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.id = 'navidul-gaming';
        script.innerHTML = `(function(){window.kx=window.kx || function(){(kx.q=kx.q||[]).push(arguments)};kx.l = +new Date;var k=document.createElement('script');k.id='k-jssdk';k.type='text/javascript';k.async=true;k.src='https://kx1.co/sdk.js?v=1.10&apiKey=Q3vqzxYOwdVyn8WJpeDN&t=1736265712';var s=document.getElementsByTagName('script')[0];if(document.getElementById(k.id)){return;}s.parentNode.insertBefore(k,s);})();`;

        if (document.getElementById(script.id)) {
            return;
        }

        document.body.appendChild(script);

        return () => {
            document.getElementById(script.id)?.remove();
            document.getElementById('navidul-gaming')?.remove(); // Limpia también el script interno si lo generó
        };
    }, []);

    const meta = [{ tag: "meta", attributes: { name: "title", content: "Navidul Gaming" } },
    { tag: "meta", attributes: { name: "description", content: "Navidul ÇGaming" } }];
    return (
        <Layout blocks={blocks} theme='ligth' layoutType='base' preFooter={true} meta={meta} canonical="/es/404">
            <div className="pt-header">
                <Container backgroundColor="bg-bg-quinary" wrapper>
                    <div className="k-contest" data-id="4Er0Sv2" data-layout="responsive" />
                </Container>
            </div>
        </Layout>

    );
};

export async function getStaticProps(
    context: GetStaticPropsContext | GetServerSidePropsContext
): Promise<GetStaticPropsResult<LayoutProps>> {

    return {
        props: {
            ...(await getGlobalElements(context)),
        },
        revalidate: revalidateTimeout
    };
}

